import { createSelector } from 'reselect';
import { RootState } from 'store/reducer';

const selectConfig = (state: RootState): RootState['config'] => state.config;

export const selectApiUrl = createSelector(selectConfig, (config: RootState['config']): string => config.apiUrl);
